import React from 'react';

import { createClassName } from 'utils/createClassName';

import './adminPageLayoutStyles.scss';

type TProps = {
  sidebarNode: React.ReactNode;
  contentNode: React.ReactNode;
};

export const AdminPageLayout = (props: TProps) => {
  const { sidebarNode, contentNode } = props;

  const createElementClassName = createClassName('admin-page-layout');

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('content-slot')}>
        {contentNode}
      </div>
      <div className={createElementClassName('sidebar-slot')}>
        {sidebarNode}
      </div>
    </div>
  );
};
